import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useResponsiveStyles } from "../../styles/useResponsiveStyles";

export const StatsRow = ({ rank, total, label, reverse, sx }) => {
    const { getFontSize } = useResponsiveStyles();

    const shouldReverseLayout = reverse || label === "Average Weighted Votes";

    return (
        <Box sx={{ ...sx, textAlign: "center" }}>
            {shouldReverseLayout ? (
                <>
                    <Typography
                        className="text-gray-500 mb-1 text-center"
                        sx={getFontSize("body1")}
                    >
                        {label}
                    </Typography>
                    <Typography
                        sx={{
                            ...styles.valueTypography,
                            ...getFontSize("stat"),
                        }}
                    >
                        {total || '-'}
                    </Typography>
                </>
            ) : (
                <>
                    <Typography
                        sx={{
                            ...styles.valueTypography,
                            ...getFontSize("stat"),
                        }}
                    >
                        #{rank}/{total}
                    </Typography>
                    <Typography
                        className="text-gray-500 mb-1 text-center text-xs"
                        sx={getFontSize("body1")}
                    >
                        {label}
                    </Typography>
                </>
            )}
        </Box>
    );
};

const styles = {
    valueTypography: {
        color: "#dc2626",
        fontWeight: 600,
    },
};

StatsRow.propTypes = {
    rank: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    reverse: PropTypes.bool,
    sx: PropTypes.object,
};
